'use strict';

/* ── Utilities ──────────────────────────────────────────────── */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function showToast(msg, dur) {
  dur = dur || 3000;
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._t);
  t._t = setTimeout(function() { t.classList.remove('show'); }, dur);
}

/* ── Scroll Gallery Engine ──────────────────────────────────── */
(function () {
  var gallery = document.getElementById('scroll-gallery');
  if (!gallery) return;

  var frames = gallery.querySelectorAll('.scroll-gallery__frame');
  var bars   = gallery.querySelectorAll('.scroll-gallery__progress-bar');
  var count  = frames.length;
  if (count === 0) return;

  // Scroll distance per image (lower = less scrolling to get through them)
  var SLIDE_FACTOR = 0.6;
  var vpHeight    = window.innerHeight;
  var scrollPerSlide = vpHeight * SLIDE_FACTOR;
  var totalHeight = scrollPerSlide * count + vpHeight;
  gallery.style.height = totalHeight + 'px';

  var currentIndex = 0;

  function showFrame(index) {
    if (index === currentIndex) return;
    frames[currentIndex].classList.remove('active');
    frames[index].classList.add('active');

    bars.forEach(function(b, i) {
      b.classList.toggle('active', i === index);
      b.classList.toggle('done', i < index);
    });
    currentIndex = index;
  }

  // Init first frame + bar
  if (frames[0]) frames[0].classList.add('active');
  if (bars[0])   bars[0].classList.add('active');

  function onScroll() {
    var rect    = gallery.getBoundingClientRect();
    var scrolled = -rect.top; // how far we've scrolled into the gallery
    if (scrolled < 0) return;

    var index = Math.min(Math.floor(scrolled / scrollPerSlide), count - 1);
    showFrame(index);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    vpHeight       = window.innerHeight;
    scrollPerSlide = vpHeight * SLIDE_FACTOR;
    totalHeight    = scrollPerSlide * count + vpHeight;
    gallery.style.height = totalHeight + 'px';
  });
})();

/* ── Header becomes solid after scrolling past intro ───────── */
(function () {
  var header = document.getElementById('header');
  if (!header) return;
  var intro = document.getElementById('scroll-intro');
  function update() {
    var threshold = intro ? intro.offsetHeight * 0.6 : window.innerHeight * 0.6;
    header.classList.toggle('scrolled', window.scrollY > threshold);
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

/* ── Scroll Intro — hide hint after scrolling ───────────────── */
(function () {
  var hint = document.querySelector('.scroll-intro__scroll-hint');
  if (!hint) return;
  window.addEventListener('scroll', function () {
    hint.style.opacity = window.scrollY > 60 ? '0' : '';
    hint.style.transition = 'opacity 0.4s';
  }, { passive: true });
})();

/* ── Mobile menu ────────────────────────────────────────────── */
(function () {
  var toggle = document.getElementById('mobile-menu-toggle');
  var menu   = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', function () {
    var open = menu.classList.toggle('open');
    document.body.style.overflow = open ? 'hidden' : '';
  });
})();

/* ── Cart Drawer ────────────────────────────────────────────── */
var CartDrawer = (function () {
  var drawer    = document.getElementById('cart-drawer');
  var overlay   = drawer && drawer.querySelector('.cart-drawer__overlay');
  var closeBtn  = drawer && drawer.querySelector('.cart-drawer__close');
  var itemsEl   = document.getElementById('cart-drawer-items');
  var subtotalEl= document.getElementById('cart-drawer-subtotal');
  var countEl   = document.getElementById('cart-count');

  function open() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refresh();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function updateCount(n) {
    if (countEl) countEl.textContent = n > 0 ? n : '';
  }
  function render(cart) {
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="text-align:center;padding:40px 0;color:#888;">Your cart is empty.</p>';
      if (subtotalEl) subtotalEl.textContent = '';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function(item) {
      return '<div class="drawer-cart-item" data-key="' + item.key + '">' +
        '<img class="drawer-cart-item__image" src="' + (item.image ? item.image.replace('.jpg','_120x135.jpg') : '') + '" alt="' + item.title + '" onerror="this.style.display=\'none\'">' +
        '<div class="drawer-cart-item__details">' +
          '<p class="drawer-cart-item__title">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="drawer-cart-item__variant">' + item.variant_title + '</p>' : '') +
          '<div class="drawer-cart-item__bottom">' +
            '<span class="drawer-cart-item__price">' + formatMoney(item.line_price) + '</span>' +
            '<button class="drawer-cart-item__remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    itemsEl.querySelectorAll('.drawer-cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() { removeItem(btn.dataset.key); });
    });
  }
  function refresh() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      render(cart); updateCount(cart.item_count);
    });
  }
  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(r){ return r.json(); }).then(function(cart) {
      render(cart); updateCount(cart.item_count);
    });
  }

  if (overlay) overlay.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
  var cartToggle = document.getElementById('cart-toggle');
  if (cartToggle) cartToggle.addEventListener('click', open);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

  return { open: open, close: close, refresh: refresh, updateCount: updateCount };
})();

/* ── Quick Add ──────────────────────────────────────────────── */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.quick-add-btn');
  if (!btn || btn.disabled) return;
  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  var orig = btn.textContent;
  btn.disabled = true; btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function(r) {
    if (!r.ok) throw new Error();
    return r.json();
  }).then(function() {
    btn.textContent = '✓';
    setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 1500);
    CartDrawer.open(); CartDrawer.refresh();
  }).catch(function() {
    btn.textContent = orig; btn.disabled = false;
    showToast('Could not add item. Please try again.');
  });
});

/* ── Product page ───────────────────────────────────────────── */
(function() {
  var form = document.getElementById('product-form');
  if (!form) return;
  var qtyIn = document.getElementById('qty-input');
  var formQty = document.getElementById('form-qty');
  var addBtn  = document.getElementById('add-to-cart-btn');
  var minus   = document.getElementById('qty-minus');
  var plus    = document.getElementById('qty-plus');

  if (minus && plus && qtyIn) {
    minus.addEventListener('click', function() {
      var v = parseInt(qtyIn.value)||1;
      if (v > 1) { qtyIn.value = v-1; if(formQty) formQty.value = v-1; }
    });
    plus.addEventListener('click', function() {
      var v = parseInt(qtyIn.value)||1;
      qtyIn.value = v+1; if(formQty) formQty.value = v+1;
    });
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (!addBtn || addBtn.disabled) return;
    var orig = addBtn.textContent;
    addBtn.disabled = true; addBtn.textContent = 'Adding...';
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: fd.get('id'), quantity: parseInt(fd.get('quantity'))||1 })
    }).then(function(r) {
      if (!r.ok) throw new Error();
      return r.json();
    }).then(function() {
      addBtn.textContent = 'Added!';
      setTimeout(function() { addBtn.textContent = orig; addBtn.disabled = false; }, 1500);
      CartDrawer.open(); CartDrawer.refresh();
    }).catch(function() {
      addBtn.textContent = orig; addBtn.disabled = false;
      showToast('Something went wrong. Please try again.');
    });
  });

  // Variant picker
  if (typeof productVariants !== 'undefined') {
    var selectedOptions = {};
    var variantIdInput  = document.getElementById('variant-id');
    var priceEl         = document.getElementById('product-price');

    document.querySelectorAll('.size-btn, .swatch').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var opt = parseInt(btn.dataset.option);
        selectedOptions[opt] = btn.dataset.value;
        btn.closest('.size-list, .swatch-list').querySelectorAll('.size-btn, .swatch')
          .forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var sel = btn.closest('.variant-option').querySelector('.variant-option__selected');
        if (sel) sel.textContent = btn.dataset.value;
        var variant = productVariants.find(function(v) {
          return v.options.every(function(o, i) { return o === selectedOptions[i+1]; });
        });
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) {
          if (variant.compare_at_price > variant.price) {
            priceEl.innerHTML = '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>' +
              '<span class="price price--sale">' + formatMoney(variant.price) + '</span>' +
              '<span class="badge badge--sale">Sale</span>';
          } else {
            priceEl.innerHTML = '<span class="price">' + formatMoney(variant.price) + '</span>';
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
        var stockStatus = document.getElementById('stock-status');
        if (stockStatus) {
          var stockText = stockStatus.querySelector('.stock-status__text');
          stockStatus.classList.toggle('stock-status--out', !variant.available);
          if (stockText) stockText.textContent = variant.available ? 'In stock, ready to ship' : 'Currently out of stock';
        }
        history.replaceState({}, '', '?variant=' + variant.id);
      });
    });

    document.querySelectorAll('.size-btn.active, .swatch.active').forEach(function(btn) {
      selectedOptions[parseInt(btn.dataset.option)] = btn.dataset.value;
    });
  }

  // Thumbnails
  var mainImg = document.getElementById('main-product-image');
  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg) mainImg.src = thumb.dataset.src;
      document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });
})();

/* ── Cart page ──────────────────────────────────────────────── */
(function() {
  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function() { window.location.reload(); });
  }
  document.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key    = btn.dataset.key;
      var input  = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (!input) return;
      var qty = parseInt(input.value)||1;
      qty = btn.dataset.action === 'plus' ? qty+1 : Math.max(0, qty-1);
      cartChange(key, qty);
    });
  });
  document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
    btn.addEventListener('click', function() { cartChange(btn.dataset.key, 0); });
  });
})();
